module.exports = __webpack_public_path__ + "assets/media/1.f0fe81fa.ogg";